import { TableData } from '@/types/reports.types';
import { ReportsColumn } from '@/types/table.types';

export const getSummaryValue = (column: ReportsColumn, data: Record<string, TableData & { date: string }>) => {
  const columnData = column.accessor(data);

  return column.Cell({ value: columnData });
};
